import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
const ChangePasswordMain = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.between("md", "lg")]: {
    width: "80%",
    margin: "0 auto",
  },
  [theme.breakpoints.up("lg")]: {
    width: "70%",
  },
  "& .invalid": {
    color: "red",
  },
  "& .valid": {
    color: "green",
  },
  "& .No_error": {
    "& p": {
      color: "rgba(11, 11, 11, 0.6)",
    },
  },
}));

const FormMain = styled("div")(({ theme }) => ({
  width: "100%",
  "& .inputsMain": {
    marginBottom: "20px",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      marginBottom: "15px",
      marginTop: "20px",
    },
  },
  "& label": {
    display: "block",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: theme.palette.colors.BlackBean,
    fontFamily: theme.typography.fontFamily,
  },
  "& input": {
    width: "100%",
    height: "48px",
    background: "#F2F2F2",
    border: "1px solid #0B0B0B",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: theme.palette.colors.BlackBean,
    fontFamily: theme.typography.fontFamily,
    padding: "10px",
  },
}));

const IconButtonMain = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "48%",
  right: "2%",
  "& svg": { fontSize: "18px" },
}));
const LinkMain = styled("div")(({ theme }) => ({
  textAlign: "right",
  "& a": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "right",
    textDecorationLine: "underline",
    color: "#0B0B0B",
  },
  "& button": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "right",
    textDecorationLine: "underline",
    color: "#0B0B0B",
    textTransform: "capitalize",
    background: "transparent",
    "&:hover": {
      background: "transparent",
    },
  },
}));

const ChangePasswordForm = styled("div")(({ theme }) => ({
  marginTop: "50px",
  paddingBottom: "180px",
  "& p": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    "&.firstchild": {
      marginTop: "20px",
    },
  },
  "& svg": { fontSize: "18px", color: "rgba(0, 0, 0, 0.54)" },
  [theme.breakpoints.down("md")]: {
    marginTop: "30px",
    paddingBottom: "100px",
  },
}));

export {
  ChangePasswordMain,
  FormMain,
  IconButtonMain,
  LinkMain,
  ChangePasswordForm,
};
